export const priceCurrencyFormater = (amountT, currencyCode = 'USD', locale = 'en-UK') => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  return formatter.format(amountT)
}



// WEBPACK FOOTER //
// ./src/helpers/priceCurrencyFormater.ts